<template>
  <div class="m-pc-list">
    <div v-wechat-title="title"></div>
    <div
      class="list-item"
      @click="go(item)"
      v-for="item in list"
      :key="item.articleId"
    >
      <div class="item-cover">
        <img
          :src="
            item.coverImageRealPath || require('../assets/images/defaut.png')
          "
          alt=""
        />
      </div>
      <div class="item-content">
        <div
          class="item-title"
          :style="{
            color: color.title.color.value,
            visibility: color.title.display.value ? 'visible' : 'hidden'
          }"
        >
          {{ item.title }}
        </div>
        <div
          class="item-summary"
          :style="{
            color: color.summary.color.value,
            visibility: color.summary.display.value ? 'visible' : 'hidden'
          }"
        >
          {{ item.summary }}
        </div>
        <div
          class="item-date"
          :style="{
            color: color.time.color.value,
            visibility: color.time.display.value ? 'visible' : 'hidden'
          }"
        >
          {{ item.createTime.substr(0, 10) }}
        </div>
      </div>
    </div>
    <pager
      :page-index="currentPage"
      :total="count"
      :page-size="pageSize"
      v-if="count > pageSize"
      @change="pageChange"
    ></pager>
    <div class="m-overall" v-if="isSetting"></div>
  </div>
</template>
<script>
// import $ from "jquery"
import {
  articleCategoryId,
  globalUserId,
  initForm,
  getSess,
  isSetting
} from "../common/sbase";
import { articleListSettingInfo } from "../common/settingData";
import { $subscriber } from "fire-wind-water";
import service from "../services/article";
import Pager from "../components/Pager";
export default {
  name: "Banner",
  data() {
    return {
      list: [],
      pageSize: 10, //每页显示10条数据
      currentPage: 1, //当前页码
      count: 0, //总记录数,
      id: "",
      isFirst: true,
      isSetting: false,
      title: "",
      color: {
        title: {
          color: {
            value: ""
          },
          display: {
            value: ""
          }
        },
        summary: {
          color: {
            value: ""
          },
          display: {
            value: ""
          }
        },
        time: {
          color: {
            value: ""
          },
          display: {
            value: ""
          }
        }
      }
    };
  },
  created() {
    console.log(this.$route.path);
    if (this.$route.path.toLowerCase().indexOf("morecolumn") > 0) {
      //多栏目模板
      this.id = articleCategoryId;
      this.getList(false);

      $subscriber.subscribe("get-actile-list", id => {
        this.id = id;
        if (!isSetting) {
          this.getList(true);
        } else {
          this.isSetting = true;
          this.getSettingData();
        }
      });
      $subscriber.subscribe("category-title", title => {
        this.title = title;
      });
    } else {
      this.id = articleCategoryId;
      if (!isSetting) {
        this.getList(true);
      } else {
        this.isSetting = true;
        this.getSettingData();
      }
    }
    $subscriber.subscribe("config-loaded", res => {
      this.color = res;
      console.log(this.color);
    });
  },
  methods: {
    getList(isMore) {
      //isMore 是否加载多栏目的列表
      let param = {
        articleCategoryId: this.id,
        globalUserId: globalUserId,
        instanceId: "",
        isRecommend: -1,
        isStick: -1,
        moduleId: "",
        num: this.pageSize,
        orderField: -1,
        start: (this.currentPage - 1) * this.pageSize,
        title: "",
        typeId: "",
        withStat: -1,
        withTemplate: 1
      };
      service.getArticleList(param).subscribe(data => {
        if (isMore) {
          this.list = data.content.items;
        }
        this.count = parseInt(data.content.total);
        if (this.isFirst) {
          this.isFirst = false;
          // window.$sk.loading.hide();//隐藏loading

          if (
            data.content.category.identity == 3 &&
            getSess(data.content.category.schemaId) == ""
          ) {
            //登陆后参与并且没有登录
            //nothing
          } else {
            if (globalUserId) {
              this.browse(data.content.category, globalUserId);
            } else {
              $subscriber.subscribe("globalUserId-loaded", id => {
                this.browse(data.content.category, id);
              });
            }
          }

          initForm(
            data.content.category.identity,
            data.content.category.schemaId,
            data.content.category.registerFormId,
            data.content.category.tenantId
          );
          if (this.$route.path.toLowerCase().indexOf("morecolumn") > 0) {
            //
          } else {
            this.title = data.content.category.title;
          }
        }
      });
    },
    pageChange(page) {
      this.currentPage = page;
      this.getList(true);
    },
    go(item) {
      window.open(item.PCUrl);
    },
    browse(category, globalUserId1) {
      let param = {
        articleCategoryId: articleCategoryId,
        browseInfo: {},
        currentUrl: window.location.href,
        globalUserId: globalUserId1,
        openId: "",
        sess: getSess(category.schemaId),
        source: "PC",
        tenantId: category.tenantId,
        weChatId: category.authorisedWeChatId
      };
      service.browseCategory(param).subscribe(data => {
        data;
      });
    },
    getSettingData() {
      this.list = articleListSettingInfo;
      this.count = 222;
    }
  },
  mounted() {
    //IE 需要单独处理下
    // console.log($('#a')[0].scrollHeight)
  },
  components: { Pager }
};
</script>
